import { render } from "./UserExpenses.vue?vue&type=template&id=2fb5d380"
import script from "./UserExpenses.vue?vue&type=script&lang=js"
export * from "./UserExpenses.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/UserExpenses.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fb5d380"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fb5d380', __exports__)) {
    api.reload('2fb5d380', __exports__)
  }
  
  module.hot.accept("./UserExpenses.vue?vue&type=template&id=2fb5d380", () => {
    api.rerender('2fb5d380', render)
  })

}


export default __exports__